<template lang="pug">
.v-info-banner.info-banner(v-if="banner" :class="{'info-product-banner': isProduct}")
	.info-banner__container.container
		.info-banner__wrap
			.info-banner__left
				.info-banner__info-wrap
					template(v-if="!isLg")
						template(v-for="(item, index) in banner.items" :key="index")
							img.info-banner__image(:src="item.image" alt="" :class="{'info-banner__image--visible': index === activeIndex}")
					.info-banner__info
						.info-banner__supertitle(v-if="banner.supertitle")
							v-svg-icon.info-banner__supertitle-icon(:icon="banner.icon")
							.info-banner__supertitle-text {{banner.supertitle}}
						h2.info-banner__title.flc(v-if="banner.title" v-html="banner.title")
						.info-banner__subtitle.flc(v-if="banner.subtitle" v-html="banner.subtitle")
					ul.info-banner__list(v-if="!isLg && banner.items && banner.items.length")
						template(v-for="(item, index) in banner.items" :key="index")
							li.info-banner__list-item.flc(:class="{'active': index === activeIndex}") {{item.supertitle}}
			.info-banner__right()
				template(v-if="banner.items")
					.info-banner__items(v-if="banner.type !== 'product' || !isProduct" )
						template( v-for="(item, index) in banner.items" :key="index")
							.info-banner__item.flc(:ref="'item' + index"
									:style="{'top': index > 0 && !isSm ? (16 + (itemHeaderHeight * index)) + 'px' : isSm ? '0' : '16px'}")
								img.info-banner__image(v-if="isLg" :src="item.imageMob" alt="" :class="{'info-banner__image--visible': index === activeIndex}")
								.info-banner__item-wrap(:class="[item.colorOption ? `info-banner__item--${item.colorOption}` : '']")
									.info-banner__item-title-wrap
										h3.info-banner__item-title(v-if="item.title" v-html="item.title")
										.info-banner__item-icon-wrap
											v-svg-icon.info-banner__item-icon(:icon="item.icon || 'products-2'")
									.info-banner__content
										.info-banner__item-text(v-if="item.text" v-html="item.text")
										ul.info-banner__item-list(v-if="item.items && item.items.length"
											:class="{'info-banner__item-list--has-many-items': item.items.length > 3}")
											template(v-for="(itemLvl2, itemLvl2Index) in item.items" :key="itemLvl2Index")
												li.info-banner__item-lvl2
													.info-banner__item-lvl2-title(v-if="itemLvl2.title") {{itemLvl2.title}}
													.info-banner__item-lvl2-text(v-if="itemLvl2.text" v-html="itemLvl2.text")
										.info-banner__item-action
											a.info-banner__item-btn.btn.btn--has-right-icon.btn--primary.btn--alt-hover(v-if="item.link" :href="item.link.link")
												.btn__text {{item.link.text}}
												.btn__icon-wrap
													v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
													v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
							.info-banner__item.info-banner__item--dummy(v-if="!isLg")
					.info-banner__items(v-else-if="banner.type === 'product' || isProduct" )
						.info-banner__item.fldfplg.flc(
							v-for="(item, index) in banner.items"
							:key="index" :ref="'item' + index"
							:class="[item.colorOption ? `info-banner__item--${item.colorOption}` : '']"
							:style="{'top': index > 0 && !isSm ? (16 + (itemHeaderHeight * index)) + 'px' : isSm ? '0' : '16px'}"
						)
							img.info-banner__image(v-if="isLg" :src="item.imageMob" alt="" :class="{'info-banner__image--visible': index === activeIndex}")
							.info-banner__item-wrap
								.info-banner__item-title-wrap
									//h3.info-banner__item-title(v-if="item.title" v-html="item.title")
									.info-banner__item-icon-wrap
										v-svg-icon.info-banner__item-icon(:icon="item.icon")
									h2.bg-banner__title.flc(v-if="banner.title" v-html="banner.title")
									span.bg-banner__subtitle.flc(v-if="banner.subtitle" v-html="banner.subtitle")
									.info-banner__item-icon-wrap(v-if="banner.icon")
										v-svg-icon.info-banner__item-icon(:icon="banner.icon")
									.bg-banner__text-wrap
										.bg-banner__text.flc(v-if="banner.text") {{banner.text}}
										.bg-banner__action.flc(v-if="banner.link")
											a.bg-banner__link.btn.btn--has-right-icon.btn--primary(:href="banner.link.link" :class="{'btn--wide': isMd}")
												.btn__text {{banner.link.text}}
												.btn__icon-wrap
													v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
													v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
									.bg-banner__list.flc(v-if="banner.list")
										.bg-banner__list-item(v-for="(item, index) in banner.list" :key="index" )
											.bg-banner__list-item_title(v-if="item.title") {{item.title}}
											.bg-banner__list-item_text(v-if="item.text") {{item.text}}
								.info-banner__content
									h3.info-banner__item-title(v-if="item.accordionTitle" v-html="item.accordionTitle")
									v-accordion.info-banner__accordion(v-if="banner.accordion" :items="item.accordion")
									.info-banner__item-text(v-if="item.text" v-html="item.text")

									.info-banner__item-action
										a.info-banner__item-btn.btn.btn--has-right-icon.btn--primary.btn--alt-hover(v-if="item.link" :href="item.link.link")
											.btn__text {{item.link.text}}
											.btn__icon-wrap
												v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
												v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")



					.bg-banner__right-bottom-bonus(v-if="banner.bonus" :class="`bg-banner__right-bottom-bonus--${banner.bonus.bgColor}`")
						v-svg-icon.bg-banner__right-bottom-bonus_icon(v-if="banner.bonus.icon" :icon="banner.bonus.icon" :class="`bg-banner__right-bottom-bonus_icon--${banner.bonus.iconBgColor}`")
						.bg-banner__right-bottom-bonus_text(v-if="banner.bonus.text" ) {{banner.bonus.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import VSvgIcon from "./helpers/v-svg-icon.vue";
import VAccordion from "../components/v-accordion.vue";

export default {
	components: {VSvgIcon, VAccordion},
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		isProduct: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			banner: null,
			activeIndex: 0,
			activeImage: this.banner?.items[0].image,
			itemHeaderHeight: 16
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				document.body.classList.remove('state--page-header-blackout');
				this.banner.items.forEach((item, index) => {
					let $currentItem = this.$refs['item' + index];
					if ($currentItem) {
						if (this.$el?.offsetTop + $currentItem[0].offsetTop - window.scrollY - window.innerHeight + (window.innerHeight / 3) < 0) {
							this.activeIndex = index;
						}
					}
				});
			}
		},

		dataSet(data) {
			this.banner = data;
			this.handleScroll();
			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
